import React from 'react';

class Switch1Icon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_1217)">
          <g filter="url(#filter0_d_241_1217)">
            <path
              d="M57.804 4H22.196C19.6025 4 17.5 6.10247 17.5 8.696V71.304C17.5 73.8975 19.6025 76 22.196 76H57.804C60.3975 76 62.5 73.8975 62.5 71.304V8.696C62.5 6.10247 60.3975 4 57.804 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M49.3904 24.7399C49.3904 19.5528 45.1859 15.3479 39.9994 15.3479C34.8129 15.3479 30.6084 19.5528 30.6084 24.7399V55.2599C30.6084 60.447 34.8129 64.6519 39.9994 64.6519C45.1859 64.6519 49.3904 60.447 49.3904 55.2599V24.7399Z"
              fill="white"
            />
            <path
              d="M57.8042 3.19995H22.1962C19.1662 3.19995 16.7002 5.66595 16.7002 8.69595V71.3039C16.7002 74.3339 19.1662 76.8 22.1962 76.8H57.8042C60.8342 76.8 63.3002 74.3339 63.3002 71.3039V8.69595C63.3002 5.66595 60.8342 3.19995 57.8042 3.19995V3.19995ZM61.7002 71.3039C61.7002 73.4519 59.9522 75.2 57.8042 75.2H22.1962C20.0482 75.2 18.3002 73.4519 18.3002 71.3039V8.69595C18.3002 6.54795 20.0482 4.79995 22.1962 4.79995H57.8042C59.9522 4.79995 61.7002 6.54795 61.7002 8.69595V71.3039Z"
              fill="#83827F"
            />
            <path
              d="M40.0006 14.5479C34.3806 14.5479 29.8086 19.1198 29.8086 24.7398V55.2618C29.8086 60.8818 34.3806 65.4538 40.0006 65.4538C45.6206 65.4538 50.1926 60.8818 50.1926 55.2618V24.7398C50.1926 19.1198 45.6206 14.5479 40.0006 14.5479V14.5479ZM48.5926 55.2618C48.5926 59.9998 44.7386 63.8538 40.0006 63.8538C35.2626 63.8538 31.4086 59.9998 31.4086 55.2618V24.7398C31.4086 20.0018 35.2626 16.1479 40.0006 16.1479C44.7386 16.1479 48.5926 20.0018 48.5926 24.7398V55.2618V55.2618Z"
              fill="#83827F"
            />
            <path
              d="M55.6525 58C56.1385 58 56.5325 57.606 56.5325 57.12C56.5325 56.634 56.1385 56.24 55.6525 56.24C55.1665 56.24 54.7725 56.634 54.7725 57.12C54.7725 57.606 55.1665 58 55.6525 58Z"
              fill="#83827F"
            />
            <path
              d="M40.0002 34.9919C37.2342 34.9919 34.9922 37.2339 34.9922 39.9999C34.9922 42.766 37.2342 45.008 40.0002 45.008C42.7662 45.008 45.0082 42.766 45.0082 39.9999C45.0082 37.2339 42.7662 34.9919 40.0002 34.9919ZM40.0002 43.062C38.3102 43.062 36.9402 41.6919 36.9402 40.0019C36.9402 38.3119 38.3102 36.9419 40.0002 36.9419C41.6902 36.9419 43.0602 38.3119 43.0602 40.0019C43.0602 41.6919 41.6902 43.062 40.0002 43.062Z"
              fill="url(#paint0_linear_241_1217)"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_1217"
            x="15.3002"
            y="1.79995"
            width="52.5996"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_1217"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_1217"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_1217"
            x1="36.4009"
            y1="35.8878"
            x2="43.1999"
            y2="43.6866"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_1217">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default Switch1Icon;
